import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import { isFunction } from '@cp/src/utils/commonUtils';
import { setBankStatementStatus } from './reducer/bankStatementSlice';
import { Dispatch } from '@reduxjs/toolkit';
import store from '@cp/src/store';
import { Roles } from '@cp/src/pages/auth/constants/AuthConstants';

export const getBankStatementResponse = async (
  lan: string,
  customerId: string,
  caseReferenceId: string,
  bankStatementErrorCallback?: () => void
) => {
  try {
    const url = getApiUrl(ApiKeys.GET_BANK_STATEMENT);
    const response = await axiosInstance.get(url, {
      headers: {
        customerreferenceid: customerId,
        loanaccountnumber: lan,
        donotHandleError: true,
        caseReferenceId: caseReferenceId,
        includeInUptimeMetrics: true
      }
    });
    return response?.data?.data;
  } catch (error) {
    if (isFunction(bankStatementErrorCallback)) {
      bankStatementErrorCallback();
    }
    return logError(error);
  }
};

export const getBankStatementStatus = (lan: string, customerId: string) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_BANK_STATEMENT_STATUS);
  const isBankStatementAccessible = store
    .getState()
    .common?.userData?.roles?.some(role =>
      [Roles.ROLE_BANK_STATEMENT_ACCESS, Roles.ROLE_CENTRAL_UNIT].includes(role as Roles)
    );
  if (!isBankStatementAccessible) {
    return;
  }
  axiosInstance
    .get(url, {
      headers: {
        customerreferenceid: customerId,
        loanaccountnumber: lan,
        donotHandleError: true
      }
    })
    .then(response => {
      if (response?.data) {
        dispatch(setBankStatementStatus(response?.data?.data));
      }
    })
    .catch(error => {
      logError(error);
    });
};

export const getPhoneNumberStatus = async ({
  lan,
  customerId,
  phoneNumbers,
  caseReferenceId,
  caseBusinessVertical
}: {
  lan: string;
  customerId: string;
  phoneNumbers: Array<string>;
  caseReferenceId: string;
  caseBusinessVertical: string;
}) => {
  const url = getApiUrl(ApiKeys.GET_PHONE_NUMBER_STATUS);
  const response = await axiosInstance.post(
    url,
    {
      numberCustomIds: phoneNumbers
    },
    {
      headers: {
        customerreferenceid: customerId,
        loanaccountnumber: lan,
        caseReferenceId,
        caseBusinessVertical,
        donotHandleError: true
      }
    }
  );
  return response?.data;
};
